import { css, cx } from '@emotion/css';

import { COLORS2, font } from '^/constants/commonStyles';

export const styles = {
  calendarDayRootWrapper: cx(
    css`
      display: flex;
      justify-content: center;
      width: 14.28%;
      position: relative;
      font-size: 13px;
      line-height: 18px;
      font-weight: 500;
    `,
  ),
  calendarDayContentWrapper: css`
      position: absolute;
      top: 0; left: 0;

      display: flex;
      justify-content: center;
      align-items: center;

      width: 100%;
      height: 100%;
  `,
  today: css`

    background-color: #F4F4F4;
    border-radius: 50%;
  `,
  start: css`

    background-color: ${COLORS2.main.MrtBlue1};
    color: ${COLORS2.main.MrtWhite};
    border-radius: 50%;
  `,
  end: css`

    background-color: ${COLORS2.main.MrtBlue1};
    color: ${COLORS2.main.MrtWhite};
    border-radius: 50%;
  `,
  inSelectionBackground: css`
    background-color: #EEF6FE;

  `,
  normal: css`
  `,
  disabled: css`
    color: ${COLORS2.sub.MrtGray2};
    cursor: not-allowed;
    pointer-events: none;
  `,
  hover: css`
  `,
  inHoverSelection: css`
    background-color: rgb(168, 212, 249, 0.5);
  `,
  rightBorderRadius50: css`
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
  `,
  leftBorderRadius50: css`
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
  `,
  rightBorderRadius0: css`
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  `,
  leftBorderRadius0: css`
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  `,
} as const;
export function getClassNameByState(state: keyof typeof styles) {
  return styles[state];
}
